import { useContext } from 'react';
import { ScrollingContext } from '../contexts/ScrollingContext';

// ----------------------------------------------------------------------

const useScrolling = () => useContext(ScrollingContext);

export default useScrolling;
